import 'babel-polyfill';
import Rails from 'rails-ujs';
import 'normalize.css';
import 'flexboxgrid/dist/flexboxgrid';
import 'react-day-picker/lib/style';
import 'picturefill';

import 'apps/application';

import 'pages/home';
import 'pages/community';
import 'pages/join-us';

import 'styles/application';
import 'styles/product/product';
import 'styles/calculator/calculator';
import 'styles/checkout/sms_subscription/subscription';

import 'images/products/all-flavors.png';
import 'images/products/4-flavors.png';
import 'images/products/mint.jpg';
import 'images/products/creme.jpg';
import 'images/products/fruit.jpg';
import 'images/products/mango.jpg';
import 'images/products/tobacco.jpg';

import 'images/mission-values/mission-hero@2x.jpg';
import 'images/mission-values/mission-hero-mobile@2x.jpg';
import 'images/mission-values/juul-pods.jpg';
import 'images/mission-values/juul-pods@2x.jpg';
import 'images/mission-values/juul-pods@3x.jpg';

import 'images/youth-education/hero@2x.jpg';
import 'images/youth-education/hero-mobile@2x.jpg';

import 'images/our-technology/mobile/hero@2x.jpg';
import 'images/our-technology/hero@2x.jpg';

import 'images/our-perspective/mobile/hero@2x.jpg';
import 'images/our-perspective/hero@2x.jpg';

import 'images/our-story/hero@2x.jpg';
import 'images/our-story/hero-mobile@2x.jpg';

import 'images/icons/icon-book.png';
import 'images/icons/icon-map.png';
import 'images/icons/icon-play.svg';
import 'images/icons/icon-refer.svg';
import 'images/icons/icon-x.svg';
import 'images/icons/icon-video-player-play.svg';

import 'images/products/devices/flat-devicekit.png';
import 'images/products/devices/juul-device-top-half.png';
import 'images/products/membership.png';

import 'images/products/blush-gold-device-staged-mobile.jpg';
import 'images/products/blush-gold-device-staged-tablet.jpg';

import 'images/products/pods-staged/J1T1810-mobile.jpg';
import 'images/products/pods-staged/J1T1810-tablet.jpg';

import 'images/products/collections/0.png';
import 'images/products/collections/1.png';
import 'images/products/collections/2.png';

import 'images/products/subscription-view.png';
import 'images/products/subscription-calendar.png';

import 'images/social/home.jpg';
import 'images/social/default.jpg';
import 'images/social/auto-ship.jpg';

import 'images/navigation/gold-blush.jpg';
import 'images/navigation/calculator@3x.jpg';
import 'images/navigation/silver-device@3x.jpg';
import 'images/navigation/refer-smoker.jpg';
import 'images/navigation/juul-nora.png';
import 'images/navigation/juul-nora-wide.jpg';
import 'images/navigation/social-rectangle.png';
import 'images/navigation/blue-ribbon.jpg';
import 'images/navigation/juul-pods.png';
import 'images/navigation/starter-kit.jpg';

import 'images/home/device.png';
import 'images/home/pod.png';
import 'images/home/usb.png';

import 'images/support/support-page-banner.jpg';

import '../../assets/images/flags/flag-us.svg';
import '../../assets/images/flags/flag-il.svg';
import '../../assets/images/flags/flag-uk.svg';

import 'styles/pages/influencers';
import 'styles/pages/intellectual-property';
import 'styles/pages/mission-values';
import 'styles/pages/nyc-law';
import 'styles/pages/nyc-retailers-legislation-timeline';
import 'styles/pages/nyc-retailers-qa';
import 'styles/pages/our-perspective';
import 'styles/pages/our-story';
import 'styles/pages/our-technology';
import 'styles/pages/terms';
import 'styles/pages/wholesale';
import 'styles/pages/youth-education';

import 'styles/support/support';

import 'styles/survey/survey';

// Setup react-rails.
// The ERB helper react_component will access to components found in directories
// under app/javascript/apps and matching the regex below.
var componentRequireContext = require.context(
  'apps',
  true,
  // Directories that contain components mounted with react-rails.
  /cart\/wrapped|forms|calculator\/wrapped|sms_subscriptions\/wrapped/
);
var ReactRailsUJS = require('react_ujs');
ReactRailsUJS.useContext(componentRequireContext);

// Setup rails-ujs
Rails.start();



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js